import { InferOutput, literal, object } from 'valibot'
import { EntityTypeGroupId } from '../../EntityTypeGroupId.enum'
import { EntityTypeMeta, entityTypeDefaults } from '../../EntityTypeMeta'
import { HasXYSchema } from '../../has_xy'
import { BaseEntitySchema } from '../BaseEntity'
import { ELEVATION_LAND_FLOOR_DEFAULT } from '../EntityElevation/elevation_consts'
import { EntityElevationSchema } from '../EntityElevation/EntityElevation.type'
import { EntityIdSchema } from '../EntityId.type'
import { EntityLayerId } from '../EntityLayerId/EntityLayerId.enum'
import { EntityTypeId } from '../EntityTypeId.enum'

const entDefaults = {
  etype_id: EntityTypeId.Plain,
  layer_id: EntityLayerId.TerrainL1,
  elevation: 1,
  floor_e: ELEVATION_LAND_FLOOR_DEFAULT,
} as const

export const PlainEntitySchema = object({
  ...BaseEntitySchema.entries,
  etype_id: literal(EntityTypeId.Plain),
  layer_id: literal(EntityLayerId.TerrainL1),
  id: EntityIdSchema,
  elevation: EntityElevationSchema,
  floor_e: EntityElevationSchema,
  ...HasXYSchema.entries,
})

export type PlainEntity = InferOutput<typeof PlainEntitySchema>

/**
 * Flat or gently rolling terrain with few natural obstacles and good visibility.
 */
export const PlainEntityTypeMeta: EntityTypeMeta = {
  ...entityTypeDefaults,
  id: EntityTypeId.Plain,
  dname: 'Plain',
  layer_id: EntityLayerId.TerrainL1,
  group_id: EntityTypeGroupId.Terrain,
  defense: 1,
  entDefaults,
}

export function createPlainEntity(id: number, x: number, y: number): PlainEntity {
  return {
    ...entDefaults,
    heading: 0,
    id,
    x,
    y,
  }
}
